/* Add to cart for hp-* product cards.
   Posts the card's form to /cart/add and shows the theme's own cart popup (notification or drawer).
   Falls back to a normal form submit (goes to the cart page) if anything goes wrong. */
(() => {
  if (window.hpAtcReady) return;
  window.hpAtcReady = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-hp-atc]');
    if (!form) return;

    // The store's Slide Cart app (if installed) takes priority over the theme's own cart popup.
    const slideCart = typeof window.SLIDECART_OPEN === 'function';
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const themeCart = cart && typeof cart.renderContents === 'function';
    if (!slideCart && !themeCart) return; // let the browser submit normally

    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const label = button.querySelector('.hp-pcard__btn-text');
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    const formData = new FormData(form);
    if (!slideCart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message);

      if (slideCart) {
        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
        window.SLIDECART_OPEN();
      } else {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
      }
      if (label) {
        label.textContent = 'Added!';
        setTimeout(() => (label.textContent = button.dataset.label), 2000);
      }
    } catch (error) {
      if (label) {
        label.textContent = error.message ? error.message.slice(0, 40) : 'Try again';
        setTimeout(() => (label.textContent = button.dataset.label), 3000);
      }
    } finally {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
    }
  });
})();
